// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  display: flex;
  flex-direction: column;
  align-self: stretch;
  border-radius: var(--Radius-radius-l, 16px);
  background: var(--Colors-UI-Neutral-Grey-0, #FFF);
  width: 100%;
  height: 100%;
}

#jsoneditor {
}

`, "",{"version":3,"sources":["webpack://./src/editor.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,2CAA2C;EAC3C,iDAAiD;EACjD,WAAW;EACX,YAAY;AACd;;AAEA;AACA","sourcesContent":[":host {\n  display: flex;\n  flex-direction: column;\n  align-self: stretch;\n  border-radius: var(--Radius-radius-l, 16px);\n  background: var(--Colors-UI-Neutral-Grey-0, #FFF);\n  width: 100%;\n  height: 100%;\n}\n\n#jsoneditor {\n}\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
